import { Component, ChangeDetectionStrategy, output, input } from '@angular/core';
import { PrimeDialogComponent } from '../prime-dialog/prime-dialog.component';
import { PrivacyNoticeComponent } from '@shared/components';

@Component({
  selector: 'privacy-dialog',
  standalone: true,
  imports: [
    PrimeDialogComponent,
    PrivacyNoticeComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './privacy-dialog.component.html',
  styleUrl: './privacy-dialog.component.scss'
})
export class PrivacyDialogComponent {
  onCloseButton = output<void>();

  visible = input(false);

  breakpoints = input<{[key: string]: string}>({ '2000px': '50vw', '900px': '70vw', '575px': '90vw' });

  onClose() {
    this.onCloseButton.emit();
  }
}
